<template>
  <div class="drag-sort-sentence-question-view">
    <!-- <div class="question-desc-view">{{questioninfo.desc}}</div> -->
    <template
      v-if="questioninfo.content_audio&&questioninfo.content_audio!=''&&questioninfo.content_audio!=null">
      <div class="question-play-btn"
           @click="playcontent(questioninfo.content_audio)">
        <div>听力材料</div>
      </div>
    </template>
    <div class="drag-sort-sentence-question-info-view" :style="showanswertype?'background:#fff':''">
      <div class="drag-sort-sentence-question-content-info-view" v-if="!showanswertype">
        <template v-if="questioninfo.options&&questioninfo.options.length>0">
          <div class="el-left-sentence-btn">
            <div class="el-sentence-top-btn" v-if="localtoppage>1&&questioninfo.options.length>0"
                 @click="prevtoppage"></div>
            <div class="el-sentence-bottom-btn" v-if="localtoppage<bottompages&&questioninfo.options.length>0"
                 @click="nexttoppage"></div>
          </div>
          <draggable :list="questioninfo.options"
                     :options="{group:{name: falgs,pull:'clone'},filter: '.undraggable', sort: false,dragClass:'drag-view'}"
                     @end="end"
                     class="group-sentence-drag1Area">
            <div v-for="(option,index) in questioninfo.options" v-if="index<8*localtoppage&&index>=(localtoppage-1)*8"
                 :data-index="index" :data-content="option.content">
              <div :id="'dragcontent'+index" class="drag-drop-group-sentence-item">{{option.content}}</div>
            </div>
          </draggable>
        </template>
        <template v-else>
          <div>
            <img src="../../assets/img/show-toast-info.png"/>
            <div style="margin-top: 10px;font-size: 24px;color: #FF9A09">所需排列的句子已经用完</div>
          </div>
        </template>
      </div>
      <div class="drag-sort-sentence-question-content-info-view1">
        <div class="el-right-sentence-btn">
          <div class="el-sentence-top-btn" v-if="localbottompage>1&&questioninfo.chosecontent.length>0"
               @click="prevbottompage"></div>
          <div class="el-sentence-bottom-btn" v-if="localbottompage<bottompages&&questioninfo.chosecontent.length>0"
               @click="nextbottompage"></div>
        </div>
        <div class="grop-sentence-chose-item" v-for="(item,index) in questioninfo.chosecontent"
             v-if="index<8*localbottompage&&index>=(localbottompage-1)*8">
          <div class="index-text"><span v-if="item.list.length>0">{{index+1}}</span></div>
          <div class="drag-sort-sentence-item">
            <div class="drag-sort-sentence-index">{{index+1}}</div>
            <draggable
              :list="item.list"
              :options="{group:item.flags, sort: false ,filter: '.group-list-complete-item-handle',disabled: disabled}"
              :data-index="index"
              class="drag-drop-sort-sentence-item">
              <div v-for="element in item.list">
                <div class="group-sentences-complete-item-handle" v-if="element"
                     @click="cancelchose(index,$event)">{{element.content}}
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>

    <audio ref="sortsentencemusic" controls="controls" style="display: none"
           preload="auto" @ended="playend">
      <source :src="audiourl" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
  import apiUtil from "@/api/apiUtils"
  import Apis from "@/api"
  import Vue from 'vue';
  import draggable from 'vuedraggable'

  export default {
    name: "dragscortsentencequestion",
    components: {draggable},
    data() {
      return {
        baseurl: apiUtil.getBaseUrl(),
        questioninfo: {},
        optionindex: 0,
        answerindex: 0,
        disabled: false,
        falgs: "article",
        showanswer: false,
        toppages: 1,
        bottompages: 1,
        localtoppage: 1,
        localbottompage: 1,
        answerpages: 1,
        localanswerpages: 1,
        showanswertype: false,
        isCanClick: false,
        showanswerdialog: false,
        audiourl: "",
        showdesc: true,
        localindex: 0,
        totalindex: 0,
        contentplay: false,
        descplay: false
      }
    },
    props: {
      questionData: {
        type: Object,
        default: function () {
          return {}
        }
      },
      isShowHead: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      "questionData": function () {
        this.initData()
      }
    },
    mounted() {
      let _this = this;
      this.$nextTick(() => {
        _this.initData()
      })
    },
    methods: {
      showdescbtn() {
        if (this.showdesc == false) {
          this.showdesc = true;
          this.$refs.sortsentencemusic.pause()
        }
      },
      initData() {
        this.questioninfo = this.paraseData(this.questionData)
        this.localindex = parseInt(localStorage.getItem("questionindex"));
        this.totalindex = parseInt(localStorage.getItem("questintotal"));
      },
      paraseData(questionData) {
        var that = this;
        var questiondata = {};
        if (!questionData.useroption) {
          questiondata = JSON.parse(JSON.stringify(questionData))
          var content = questiondata.content;
          var contents = content.split("|");
          questiondata.answers = contents
          var options = []
          var chosecontent = []
          contents.forEach(item => {
            options.push({
              content: item,
              list: [],
            })
            chosecontent.push({
              content: item,
              list: [],
              flags: "article"
            })
          })
          questiondata.options = that.randomSort(options);
          questiondata.chosecontent = chosecontent;
        } else {
          questiondata = JSON.parse(JSON.stringify(questionData))
        }
        this.toppages = parseInt(Math.ceil(questiondata.options.length / 8));
        this.bottompages = parseInt(Math.ceil(questiondata.chosecontent.length / 8));
        return questiondata;
      },
      nextbottompage() {
        this.localbottompage += 1;
        if (this.localbottompage > this.bottompages) {
          this.localbottompage = this.bottompages
        }
      },
      prevbottompage() {
        this.localbottompage -= 1;
        if (this.localbottompage < 0) {
          this.localbottompage = 0
        }
      },
      nexttoppage() {
        this.localtoppage += 1;
        if (this.localtoppage > this.toppages) {
          this.localtoppage = this.toppages
        }
      },
      prevtoppage() {
        this.localtoppage -= 1;
        if (this.localtoppage < 0) {
          this.localtoppage = 0
        }
      },

      hasClass(elements, cName) {
        return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
      },
      addClass(elements, cName) {
        if (!this.hasClass(elements, cName)) {
          elements.className += " " + cName;
        }
        ;
      },
      removeClass(elements, cName) {
        if (this.hasClass(elements, cName)) {
          elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " ");
        }
      },
      end(ev) {
        if (ev.to.className == 'drag-drop-sort-sentence-item') {
          if (ev.to.childElementCount == 1) {
            this.isCanClick = true;
            this.questioninfo.options.splice(ev.clone.dataset.index, 1)
            this.questioninfo.chosecontent[ev.to.dataset.index].flags = "111"
            this.questioninfo.chosecontent[ev.to.dataset.index].selectindex = ev.clone.dataset.index
          }
        }
        this.checkanswer()
      },
      checkanswer() {
        this.questioninfo.isfinish = true;
        var useroption = [];
        this.questioninfo.chosecontent.forEach((item, index) => {
          if (item.list.length > 0) {
            useroption.push([item.content, item.list[0].content])
          } else {
            useroption.push([item.content, ""])
          }
        })
        this.questioninfo.useroption = useroption;
        this.questioninfo.isfinish = true;
        this.$emit("questionfinish", this.questioninfo)
        this.$forceUpdate();
      },
      cancelchose(index, event) {
        if (this.questioninfo.chosecontent[index].list.length > 0) {
          var item = this.questioninfo.chosecontent[index].list[0]
          this.questioninfo.chosecontent[index].flags = "article"
          this.questioninfo.chosecontent[index].list = []
          this.questioninfo.options.splice(this.questioninfo.chosecontent[index].selectindex, 0, item)
        }
        event.stopPropagation()
      },

      playcontent() {
        var audiourl = apiUtil.getBaseUrl() + this.questioninfo.content_audio;
        this.$refs.sortsentencemusic.src = audiourl;
        if (this.$refs.sortsentencemusic.paused) {
          this.$refs.sortsentencemusic.play()
          this.contentplay = true
        }
      },

      prev() {
        this.$refs.sortsentencemusic.pause()
        this.descplay = false;
        this.contentplay = false;
        this.$emit("goToPrev")
      },
      next() {
        this.$refs.sortsentencemusic.pause()
        this.descplay = false;
        this.contentplay = false;
        this.$emit("goToNext")
      },
      playend() {
        this.descplay = false;
        this.contentplay = false;
      }

    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .drag-sort-sentence-question-view {
    width 100%;
    height 100%;
  }

  .drag-sort-sentence-question-info-view {
    display flex;
    width 100%;
    height 80%;
    position relative;
    display flex;
    justify-content space-around;
    align-items center;
  }

  .el-sentence-top-btn {
    width 38px;
    height 38px;
    background url("../../assets/img/el-up-btn.png");
    background-size 100% 100%;
  }

  .el-left-sentence-btn {
    position absolute;
    left -20px;
    display flex;
    flex-direction column;
  }

  .el-right-sentence-btn {
    position absolute;
    right -20px;
    display flex;
    flex-direction column;
  }

  .el-sentence-bottom-btn {
    width 38px;
    height 38px;
    background url("../../assets/img/el-down-btn.png");
    background-size 100% 100%;
  }

  .drag-sort-sentence-question-content-info-view {
    width 50%;
    height 90%;
    margin 10px auto;
    display flex;
    flex-direction column;
    align-items center;
    justify-content space-around;
    position relative;
  }

  .drag-sort-sentence-question-content-info-view1 {
    width 50%;
    height 90%;
    margin 10px auto;
    display flex;
    flex-direction column;
    align-items center;
    justify-content space-around;
  }

  .group-sentence-drag1Area {
    width 100%;
    height 100%;
    display flex;
    flex-direction column;
    align-items center;
    justify-content space-around;
    overflow-y auto;
  }

  .drag-drop-group-sentence-item {
    width: 618px;
    padding 10px 0;
    background: #FF9A09;
    display flex;
    align-items center;
    justify-content center;
    border-radius: 12px;
    font-size: 28px;
    font-weight: 400;
    margin 5px;
  }

  .word-drag1Area-item {
    width: 618px;
    height: 55px;
    display flex;
    align-items center;
    justify-content center;
    border-radius: 12px;
    font-size: 28px;
    font-weight: 400;
    background #fff;
    border 3px solid #131313;
    margin 5px;
    display flex;
    border-radius 12px;
  }

  .drag-sort-sentence-item {
    width: 618px;
    padding 10px 0;
    border-radius: 12px;
    font-size: 60px;
    background #fff;
    border 3px solid #131313;
    margin 5px;
    border-radius 12px;
    display flex;
    align-items center;
    justify-content center;
  }

  .drag-sort-sentence-index {
    font-size 28px;
    color #FF9A09;
  }

  .grop-sentence-chose-item {
    display flex;
    justify-content center;
    align-items center;
    font-size 50px;
    margin-right 30px;

    .index-text {
      width 30px;
      margin-bottom 5px;
    }
  }

  .group-sentences-complete-item-handle {
    border-radius 12px;
    background #fff;
    display flex;
    align-items center;
    justify-content center;
    align-self center;
  }

  .drag-drop-sort-sentence-item {
    width: 618px;
    padding 10px 0;
    display flex;
    align-items center;
    justify-content center;
    border-radius 12px;
    font-size 28px;
    font-weight 400;
    position absolute;
  }

  .sort-sentence-answer-icon {
    width 50px;
    height 50px;
    margin-right 10px;
    display flex;
    align-items center;
  }

  /**
   * 答案展示和弹窗样式
   */

  .drag-sort-sentent-bottom-view {
    width 100%;
    height 90px;
    position absolute;
    bottom 0;

    .sort-sentence-finish-btn {
      width 50%;
      height 72px;
      font-size 36px;
      position absolute;
      left 25%;
      bottom 30px;
      border-radius 36px;
      background #5777FF;
      color #fff;
    }
  }

  .drag-sort-sentent-finish-view {
    width 100%;
    height 90px;
    display flex;
    position absolute;
    bottom 0;
  }

  .drag-sort-sentent-answer-right-bottom-view img {
    margin-right 15px;
  }

  .drag-sort-sentent-answer-right-bottom-view {
    display flex;
    flex 1;
    height 100%;
    justify-content center;
    align-items center;
    color #fff;
    font-size 36px;
    background #92C761;
  }

  .drag-sort-sentent-finish-wrong {
    width: 100%;
    height 100%;
    display flex;
    justify-content center;
    align-items center;

    .drag-sort-sentent-answer-wrong-bottom-view {
      display flex;
      flex 1;
      height 100%;
      justify-content center;
      align-items center;
      color #fff;
      font-size 36px;
      background #F45578;
    }

    .drag-sort-sentent-answer-wrong-bottom-view img {
      margin-right 15px;
    }

    .drag-sort-sentent-show-answer-btn {
      font-size 24px;
      color #fff;
      padding 0 15px;
      display flex;
      height 100%;
      flex-direction column;
      justify-content center;
      align-items center;
      background #92C761;
    }
  }

  .drag-sort-sentence-show-answer-dialog {
    width 100%;
    height 100%;
    position fixed;
    top 0;
    left 0;
    background #65d67a;
    z-index 1500;
    display flex;
    flex-direction column;
    justify-content center;
    align-items center;
  }

  .close-answer-dialog {
    background url("../../assets/img/answer-close-bg.png")
    background-size 100% 100%;
    width 180px;
    height 180px;
    position absolute;
    left -90px;
    top -90px;
  }

  .show-drag-sort-sentence-content-info {
    width 90%;
    height 100%;
    display flex;
    flex-direction column;
    align-items center;
    justify-content space-around;
    position absolute;
    left 5%;
  }

  .dialog-toast-text {
    margin-top 24px;
    font-size 36px;
    color #131313;
    font-weight bold;
  }

  .answer-sort-sentence-item-view {
    font-size 36px;
    display flex;
    align-items center;

    .answer-sort-sentence-text {
      border 3px solid #000000;
      width 618px;
      padding 5px 0;
      margin 10px 30px;
      font-size 28px;
      border-radius: 12px;
    }
  }

  .show-drag-sort-sentence-answer-content-view {
    width 88.5%;
    height 71.1%;
    background #fff;
    border-radius 12px;
    position relative;
    display flex;
    align-items center;
  }

  @media screen and (max-width: 1600px) {
    .drag-sort-sentence-question-info-view {
    }

    .drag-drop-group-sentence-item {
      width: 600px;
      padding 5px 0;
      background: #FF9A09;
      display flex;
      align-items center;
      justify-content center;
      border-radius: 12px;
      font-size: 22px;
      font-weight: 400;
      margin 5px;
    }

    .drag-drop-sort-sentence-item {
      width: 600px;
      padding 5px 0;
      display flex;
      align-items center;
      justify-content center;
      border-radius 12px;
      font-size 22px;
      font-weight 400;
      position absolute;
    }

    .drag-sort-sentence-item {
      width: 520px;
      padding 2px 0;
      border-radius: 12px;
      font-size: 22px;
      background #fff;
      border 3px solid #131313;
      margin 5px;
      border-radius 12px;
      display flex;
      align-items center;
      justify-content center;
    }

    .drag-sort-sentence-index {
      font-size 20px;
      color #FF9A09;
    }

    .grop-sentence-chose-item {
      display flex;
      justify-content center;
      align-items center;
      font-size 22px;

      .index-text {
        width 30px;
        margin-bottom 5px;
      }
    }

    .sort-sentence-answer-icon {
      width 30px;
      height 30px;
      margin-right 10px;
      display flex;
      align-items center;
    }

    .sort-sentence-answer-right {
      width 30px;
      height 30px;
    }

    .sort-sentence-answer-wrong {
      width 30px;
      height 30px;
    }

    .answer-sort-sentence-item-view {
      font-size 22px;
      display flex;
      align-items center;

      .answer-sort-sentence-text {
        border 3px solid #000000;
        width: 600px;
        padding 5px 0;
        margin 5px 30px;
        font-size 22px;
        border-radius: 12px;
      }
    }

    .drag-sort-sentent-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;

      .sort-sentence-finish-btn {
        width 50%;
        height 48px;
        font-size 24px;
        position absolute;
        bottom 5px;
      }
    }

    .drag-sort-sentent-finish-view {
      width 100%;
      height 50px;
      display flex;
      position absolute;
      bottom 0;
    }

    .drag-sort-sentent-answer-right-bottom-view {
      display flex;
      flex 1;
      height 100%;
      justify-content center;
      align-items center;
      color #fff;
      font-size 24px;
      background #92C761;
    }

    .drag-sort-sentent-answer-right-bottom-view img {
      width 40px;
      height 40px;
      margin-right 15px;
    }

    .drag-sort-sentent-finish-wrong {
      width: 100%;
      height 100%;
      display flex;
      justify-content center;
      align-items center;

      .drag-sort-sentent-answer-wrong-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 24px;
        background #F45578;
      }

      .drag-sort-sentent-answer-wrong-bottom-view img {
        width 40px;
        height 40px;
        margin-right 15px;
      }

      .drag-sort-sentent-show-answer-btn {
        font-size 18px;
        color #fff;
        padding 0 15px;
        display flex;
        height 100%;
        flex-direction column;
        justify-content center;
        align-items center;
        background #92C761;
      }

      .drag-sort-sentent-show-answer-btn img {
        width 20px;
        height 20px;
      }
    }
  }

  @media screen and (max-width: 1366px) {
    .drag-sort-sentence-question-info-view {
      display flex;
      width 100%;
      height 80%;
      position relative;
      display flex;
      justify-content space-around;
      align-items center;

      .drag-drop-group-sentence-item {
        width: 600px;
        padding 5px 0;
        background: #FF9A09;
        display flex;
        align-items center;
        justify-content center;
        border-radius: 12px;
        font-size: 22px;
        font-weight: 400;
        margin 5px;
      }

      .drag-drop-sort-sentence-item {
        width: 600px;
        padding 5px 0;
        display flex;
        align-items center;
        justify-content center;
        border-radius 12px;
        font-size 22px;
        font-weight 400;
        position absolute;
      }

      .drag-sort-sentence-item {
        width: 520px;
        padding 2px 0;
        border-radius: 12px;
        font-size: 22px;
        background #fff;
        border 3px solid #131313;
        margin 5px;
        border-radius 12px;
        display flex;
        align-items center;
        justify-content center;
      }

      .drag-sort-sentence-index {
        font-size 20px;
        color #FF9A09;
      }

      .grop-sentence-chose-item {
        display flex;
        justify-content center;
        align-items center;
        font-size 22px;

        .index-text {
          width 30px;
          margin-bottom 5px;
        }
      }

      .sort-sentence-answer-icon {
        width 30px;
        height 30px;
        margin-right 10px;
        display flex;
        align-items center;
      }

      .sort-sentence-answer-right {
        width 30px;
        height 30px;
      }

      .sort-sentence-answer-wrong {
        width 30px;
        height 30px;
      }

      .answer-sort-sentence-item-view {
        font-size 22px;
        display flex;
        align-items center;

        .answer-sort-sentence-text {
          border 3px solid #000000;
          width: 600px;
          padding 5px 0;
          margin 5px 30px;
          font-size 22px;
          border-radius: 12px;
        }
      }

      .drag-sort-sentent-bottom-view {
        width 100%;
        height 50px;
        position absolute;
        bottom 0;

        .sort-sentence-finish-btn {
          width 50%;
          height 48px;
          font-size 24px;
          position absolute;
          bottom 5px;
        }
      }

      .drag-sort-sentent-finish-view {
        width 100%;
        height 50px;
        display flex;
        position absolute;
        bottom 0;
      }

      .drag-sort-sentent-answer-right-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 24px;
        background #92C761;
      }

      .drag-sort-sentent-answer-right-bottom-view img {
        width 40px;
        height 40px;
        margin-right 15px;
      }

      .drag-sort-sentent-finish-wrong {
        width: 100%;
        height 100%;
        display flex;
        justify-content center;
        align-items center;

        .drag-sort-sentent-answer-wrong-bottom-view {
          display flex;
          flex 1;
          height 100%;
          justify-content center;
          align-items center;
          color #fff;
          font-size 24px;
          background #F45578;
        }

        .drag-sort-sentent-answer-wrong-bottom-view img {
          width 40px;
          height 40px;
          margin-right 15px;
        }

        .drag-sort-sentent-show-answer-btn {
          font-size 18px;
          color #fff;
          padding 0 15px;
          display flex;
          height 100%;
          flex-direction column;
          justify-content center;
          align-items center;
          background #92C761;
        }

        .drag-sort-sentent-show-answer-btn img {
          width 20px;
          height 20px;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/public/dragsortsentencequestion.vue